import _ from "lodash";
import {OtherDocumentClause} from "common/types/clause_preview";
import clausePreviewKey from "modules/documents/utils/clause_preview_key";
import {ClausePreviewsState} from "modules/documents/reducers/clause_previews";
import {parseOtherDocumentClause} from "./parse_clause_object";

const MARKER_PATTERN = /<<(.*?)>>/g;

function extractOtherDocumentClauses(
  text: string,
  documentId: number,
): OtherDocumentClause[] {
  return Array.from(text.matchAll(MARKER_PATTERN)).flatMap(([, content]) => {
    try {
      const clause = parseOtherDocumentClause(content, documentId);
      return clause ? [clause] : [];
    } catch {
      return [];
    }
  });
}

// Clauses in other family documents cited by the reason texts, grouped
// by document, skipping any already in the store or outside the family
export default function collectOtherDocumentClauses(
  reasonTexts: Array<string | null>,
  documentId: number | undefined,
  familyDocumentIds: number[] | undefined,
  clausePreviews: ClausePreviewsState,
): OtherDocumentClause[][] {
  if (documentId === undefined || familyDocumentIds === undefined) {
    return [];
  }
  const clauses = reasonTexts.flatMap(text =>
    text ? extractOtherDocumentClauses(text, documentId) : [],
  );
  const needed = _.uniqBy(clauses, clausePreviewKey).filter(
    clause =>
      familyDocumentIds.includes(clause.document_id) &&
      !clausePreviews[clausePreviewKey(clause)],
  );
  return Object.values(_.groupBy(needed, clause => clause.document_id));
}
